let BASEURLFrontend = process.env.REACT_APP_URL;

// If running locally, add port
if (window && window.location && window.location.hostname === "localhost") {
	const port = window.location.port || "3000"; // default port if not set
	BASEURLFrontend = `http://localhost:${port}`;
}

export default BASEURLFrontend